import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Payments() {
  const [txns, setTxns] = useState([]);

  useEffect(() => {
    api.get("/payments/transactions").then((r) => setTxns(r.data));
  }, []);

  const total = txns.filter((t) => t.payment_status === "paid").reduce((s, t) => s + (t.amount || 0), 0);

  return (
    <div className="p-8 md:p-12" data-testid="payments-page">
      <div className="mb-10">
        <div className="text-[#FF331F] text-xs uppercase tracking-[0.3em] font-bold mb-2">Revenue</div>
        <h1 className="font-display uppercase text-4xl md:text-5xl tracking-tight">Payments.</h1>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        <div className="border border-[#27272A] bg-[#0F0F0F] p-6" data-testid="payments-total">
          <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 font-bold mb-3">Total collected</div>
          <div className="font-display uppercase text-4xl text-[#FF331F]">${total.toFixed(2)}</div>
        </div>
        <div className="border border-[#27272A] bg-[#0F0F0F] p-6" data-testid="payments-count">
          <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 font-bold mb-3">Transactions</div>
          <div className="font-display uppercase text-4xl">{txns.length}</div>
        </div>
        <div className="border border-[#27272A] bg-[#0F0F0F] p-6" data-testid="payments-paid">
          <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 font-bold mb-3">Paid</div>
          <div className="font-display uppercase text-4xl text-emerald-400">{txns.filter((t) => t.payment_status === "paid").length}</div>
        </div>
        <div className="border border-[#27272A] bg-[#0F0F0F] p-6" data-testid="payments-pending">
          <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 font-bold mb-3">Pending</div>
          <div className="font-display uppercase text-4xl text-zinc-400">{txns.filter((t) => t.payment_status !== "paid").length}</div>
        </div>
      </div>

      <div className="border border-[#27272A] bg-[#0F0F0F]">
        <table className="w-full text-sm" data-testid="payments-table">
          <thead className="border-b border-[#27272A] text-zinc-500 uppercase tracking-widest text-[10px]">
            <tr>
              <th className="text-left p-4">Date</th>
              <th className="text-left p-4">Customer</th>
              <th className="text-left p-4">Package</th>
              <th className="text-right p-4">Amount</th>
              <th className="text-left p-4">Status</th>
            </tr>
          </thead>
          <tbody>
            {txns.length === 0 ? (
              <tr><td colSpan={5} className="p-12 text-center text-zinc-500">No transactions yet.</td></tr>
            ) : txns.map((t) => (
              <tr key={t.id} className="border-b border-[#27272A] hover:bg-[#121212]" data-testid={`txn-row-${t.id}`}>
                <td className="p-4 text-zinc-400">{new Date(t.created_at).toLocaleDateString()}</td>
                <td className="p-4 text-zinc-300">{t.user_email}</td>
                <td className="p-4 text-zinc-400">{t.package_name}</td>
                <td className="p-4 text-right font-display text-white">${t.amount?.toFixed(2)}</td>
                <td className="p-4"><span className={`text-[10px] uppercase tracking-widest px-2 py-1 ${t.payment_status === "paid" ? "bg-emerald-500/10 text-emerald-400" : "bg-zinc-800 text-zinc-400"}`}>{t.payment_status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
